var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-absolute",class:{ 'grey darken-4': _vm.skinData==='dark', 'white': _vm.skinData==='light', 'gray lighten-5': _vm.skinData === 'gray' }},[_c('div',{staticClass:"load-container"},[_c('div',{staticClass:"loader",class:{ 'dark': _vm.skinData==='light' || _vm.skinData==='gray' }})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e87656c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = null
// module chunks = 